module.exports = __webpack_public_path__ + "static/media/note-site.72a6a60c.png";